import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as i18next from 'i18next';
import * as flights from 'core/flights';
import { TrainCoachPlaceSelectComponent } from './train-coach-place-select';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component({
    components: {
        'train-coach-place-select': TrainCoachPlaceSelectComponent
    }
})
export class FlightsBookingSeatsComponent extends Vue {
    @Prop()
    reservation: flights.ReservationModel;

    @Prop()
    v: any;

    onGoBack() {
        this.$emit('back');
    }

    onSubmit() {
        this.v.trains.$touch();

        if (this.v.trains.$error) {

            let title = i18next.t('error');
            let error = '';

            this.reservation.trains.forEach((train, index) => {
                if (!error) {
                    if (!error
                        && this.v.trains.$each[index].selectedPlaces.$error) {
                        error = i18next.t('error_train_places');
                    }
                }
            });

            (<any>this.$root).$refs.messageDialog.show({
                title: title,
                message: error
            });
        } else {
            this.$emit('submit');
        }
    }
}
